var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 9.9604L10.0001 1.66675L18.3334 9.9604M16.8183 8.45246V15.9921C16.8183 16.3921 16.6586 16.7756 16.3745 17.0584C16.0903 17.3412 15.705 17.5001 15.3031 17.5001H4.69705C4.29521 17.5001 3.90982 17.3412 3.62568 17.0584C3.34153 16.7756 3.1819 16.3921 3.1819 15.9921V8.45246M7.72735 17.5001V11.4683H12.2728V17.5001",
    stroke: "#BBBBF9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.94445ee949730fa418f608285fbe1945.svg";
export { ForwardRef as ReactComponent };